import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.funkprotokoll-report-pdf';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenFunkprotokollReportPdfEffects {

    FunkprotokollReportPdf$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_FUNKPROTOKOLL_REPORT_PDF),
        mergeMap((x: ac.GetFunkprotokollReportPdfAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getFunkprotokollReportPdf(x.veranstaltung_id, x.reportVersion, x.fall_id).pipe(
                map((result: any) => {
                    return new ac.GetFunkprotokollReportPdfErfolgreichAction(result, x.veranstaltung_id, x.reportVersion, x.fall_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetFunkprotokollReportPdfFehlerAction(error, x.veranstaltung_id, x.reportVersion, x.fall_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunkprotokollQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunkprotokollQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunkprotokollQueryService);
        }
        return this.service;
    }
}
